module.exports = __webpack_public_path__ + "static/img/yujian-logo.be20c0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yujian-logo.jpg
// module id = sFfG
// module chunks = 6